

import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import Datetime from 'vux/src/components/datetime/index.vue'


import navbar from '@/components/ui/navbar';
import cardbox from '@/components/ui/cardbox';
import dialogbox from '@/components/ui/dialogbox';
import inputbox from '@/components/ui/inputbox';
import buttonbox from '@/components/ui/buttonbox';

export default {
components: {
cardbox,navbar,dialogbox,inputbox,buttonbox,Datetime
},
data(){
return {
myInfo: {},
dialogName: {
title: '修改用户信息',
show: false,
type: '',
style: 'height:16rem; margin-top:6rem;',
},
userInfo: {
nickname: '',
portrait: '',
birthday: '',
}
}
},
methods:{


logout(){

const opts = {
url: api.logout,
type: 'get',
}
common.query(opts).then(res=>{
this.$vux.toast.text('已退出登录','top');
common.storage('userInfo','');
this.$router.push("/login");
},res=>{
this.$vux.toast.text('已退出登录','top');
common.storage('userInfo','');
this.$router.push("/login");
})
},


changeFile(files){
const file = files.target.files[0];
files.target.value = '';

if(!file){
return false;
}

if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
this.$vux.toast.text('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种','top');
return false
}

let formData = new FormData();
formData.append("avatar", file);
const opts = {
url: api.myInfoModHead,
data: formData,
processType: "file",
contentType: true,
}
common.query(opts).then(res=>{
this.$vux.toast.text("上传成功");
this.userInfo.portrait = res.data;
},res=>{
this.$vux.toast.text(res.message,'top');
})

},


userInfoUpdata(){

const info = this.userInfo;

if(info.nickname.length < 1){
this.$vux.toast.text('呢称不能为空');
return false;
}

const opts = {
url: api.myInfoMod,
data: {
...info,
},
type: 'put'
}

common.query(opts).then(res=>{
this.dialogName.show = false;
this.queryMyInfo();
},res=>{
this.$vux.toast.text(res.message)
})
},


modName(){
this.dialogName.show = true;
},


queryMyInfo(){

const opts = {
url: api.myInfo,
data: {},
type: 'get'
}
common.query(opts).then(res=>{
this.myInfo = res.data;
this.userInfo = {
nickname: res.data.nickname,
portrait: res.data.portrait,
birthday: res.data.birthday === '1970-01-01' ? '':res.data.birthday,
}
common.storageJson("userInfo",res.data);
},res=>{
this.$vux.toast.text(res.message);
});
},

},
mounted(){

this.queryMyInfo();

},
}




// WEBPACK FOOTER //
// ./src/views/member/profile.vue